import { HEADER_TOGGLE_MENU_MOBILE_SLIDE } from './constants';
import { LOCATION_CHANGE } from 'react-router-redux/reducer';

import _ from 'lodash';

const initialState = {
    stateOpenMenuMobileSlide: false,
    versionOpenMenuMobileSlide: ''
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case HEADER_TOGGLE_MENU_MOBILE_SLIDE:
            return _.merge({}, state, {
                stateOpenMenuMobileSlide: !state.stateOpenMenuMobileSlide,
                versionOpenMenuMobileSlide: !state.stateOpenMenuMobileSlide
                    ? action.versionMenu
                    : ''
            });
        case LOCATION_CHANGE:
            return { ...state, stateOpenMenuMobileSlide: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/services/header/reducer.js